export default __webpack_public_path__ + "static/media/Challenge@2x.55b58679.png";